import AiPlaygroundRoute from "./routes";

export default store => ({
  path: "ai-playground",
  childRoutes: [AiPlaygroundRoute(store)],
});
